import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-system-job-types-breadcrumbs',
  templateUrl: './system-job-types-breadcrumbs.component.html',
  styleUrls: ['./system-job-types-breadcrumbs.component.css']
})
export class SystemJobTypesBreadcrumbsComponent implements OnInit {

  @Input() 
  @Input() job_type_name?;
  @Input() job_type_id?;
  @Input() job_type_location_name?;
  @Input() job_type_location_id?;
  @Input() job_type_court_name?;
  @Input() job_type_court_id?;
  @Input() job_type_document_type_name?;
  @Input() job_type_document_type_id?;

  constructor() { }

  ngOnInit() {
  }

}
